import React from 'react';
import {
  withMeta,
  withSystem,
  Plugins,
  type ExpressionPath,
} from '@packages/systems/wfdl';
import {
  ExpressionEditor,
  extendExpressionEditorActionAtPath,
} from '@packages/systems/ExpressionEditor-utils';
import {TTypeConstructor} from '@packages/systems/wfdl-ast';
import {qualify, typeName, pluginName} from '@packages/systems/wfdl-Qualified';
import {reportBug} from '@packages/utilities/reporter';
import {createIntegratedRootAlias} from '@packages/utilities/integrated-types';
import {
  type ContextualExpression,
  ContextualExpressions,
} from '@packages/utilities/contextual-expression';

const {getIn} = ContextualExpressions;

const CHILDREN_PATH: ExpressionPath = [{in: 'Record', at: 'children'}];

const childrenType = withSystem(
  {
    label: 'Show page count',
    labelVariant: 'hidden',
  },
  TTypeConstructor(
    qualify(Plugins.name('Pagination'), typeName('ShowPageCount'))
  )
);

const fields = {
  tag: withMeta(
    {variant: 'menu'},
    withSystem(
      {
        defaultValue: 'div',
        label: 'Tag',
        private: true,
        isLocalizable: true,
      },
      TTypeConstructor(qualify(pluginName('Basic'), typeName('TagsDropdown')))
    )
  ),
  // Show page count adds/removes PaginationCount — not a replaceable leaf.
  children: childrenType,
} as const;

const PaginationRender = ({
  expr,
  dispatch,
}: {
  expr: ContextualExpression;
  dispatch: (arg1: any) => void;
}) => {
  const children = getIn(expr, CHILDREN_PATH);

  if (!children) {
    reportBug(
      'PlatformPaginationTypeChildrenError',
      'PaginationType has undefined `children`.',
      {
        team: 'platform',
        ticket: 'https://webflow.atlassian.net/browse/PLAT-1006',
      }
    );

    return null;
  }

  return (
    <ExpressionEditor
      expression={children}
      dispatch={extendExpressionEditorActionAtPath(dispatch)(CHILDREN_PATH)}
    />
  );
};

const PaginationType = createIntegratedRootAlias({
  params: ['extraAtomFields'],
  fields,
  render: PaginationRender,
});

export default PaginationType;
